import React from "react";

import { ToastContainer } from "react-toastify";
import { createRoot } from "react-dom/client";

// redux
import { Provider } from "react-redux";
import { store } from "./store";

// components
import ProductFilter from "./components/ProductFilter.js";
import ProductCategoryFilter from "./components/ProductCategoryFilter.js";
import Navigation from "./components/Navigation.js";
import Accessories from "./components/Accessories.js";
import RelatedProducts from "./components/RelatedProducts.js";
import ProductArticles from "./components/ProductArticles.js";
import Cart from "./components/Cart/Cart.js";
import MiniCart from "./components/Cart/MiniCart.js";
import ClearCart from "./components/Cart/ClearCart";
import QuickSearch from "./components/QuickSearch/QuickSearch";

// toastify
import "react-toastify/dist/ReactToastify.min.css";

function renderComponent(elemFunc, className) {
  let elementRoots = document.querySelectorAll(className);
  if (elementRoots) {
    elementRoots.forEach((root) => {
      const rootInstance = createRoot(root);
      rootInstance.render(<Provider store={store}>{elemFunc(root)}</Provider>);
    });
  }
}

//
renderComponent((root) => {
  return (
    <ProductCategoryFilter productAreaCode={root.dataset.productAreaCode} />
  );
}, ".react-root-productcategory-filter");

//
renderComponent((root) => {
  return <ProductFilter productAreaCode={root.dataset.productAreaCode} />;
}, ".react-root-product-filter");

//
renderComponent((root) => {
  return (
    <ProductArticles
      productCode={root.dataset.productCode}
      hideSeries={root.dataset.hideSeries}
      footNoteData={root.dataset.footnotedata}
    />
  );
}, ".react-root-series-filter");

//
renderComponent((root) => {
  return <Accessories productCode={root.dataset.productCode} />;
}, ".react-root-accessories");

//
renderComponent((root) => {
  return <RelatedProducts productCode={root.dataset.productCode} />;
}, ".react-root-relatedproducts");

//
renderComponent(() => {
  return <Cart isCheckout />;
}, ".react-root-cart");

//
renderComponent(() => {
  return <ClearCart />;
}, ".react-root-clearcart");

//
renderComponent(() => {
  return (
    <>
      <MiniCart />
      <ToastContainer limit={5} />
      {/* 
        ToastContainer is here because this component is present on all pages
        and therefore would clash other instances of ToastContainer on other roots 
      */}
    </>
  );
}, ".react-root-mini-cart");

//
renderComponent(() => {
  return <Navigation />;
}, ".react-root-navigation");

//
renderComponent(() => {
  return <QuickSearch />;
}, ".react-root-quick-search");
